// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-overlay[data-v-f8a3953c] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  padding: 20px;
  animation: fadeIn-f8a3953c 0.2s ease;
}
@keyframes fadeIn-f8a3953c {
from {
    opacity: 0;
}
to {
    opacity: 1;
}
}
.modal-container[data-v-f8a3953c] {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: slideIn-f8a3953c 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}
@keyframes slideIn-f8a3953c {
from {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
}
to {
    transform: scale(1) translateY(0);
    opacity: 1;
}
}
.modal-header[data-v-f8a3953c] {
  padding: 20px 24px;
  border-bottom: 2px solid #007bff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.modal-header h3[data-v-f8a3953c] {
  margin: 0;
  color: white;
  font-size: 20px;
  font-weight: 600;
}
.close-button[data-v-f8a3953c] {
  background: none;
  border: none;
  font-size: 28px;
  color: white;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.close-button[data-v-f8a3953c]:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}
.modal-body[data-v-f8a3953c] {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
  background: #fafafa;
}
.search-container[data-v-f8a3953c] {
  margin-bottom: 20px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.search-box[data-v-f8a3953c] {
  position: relative;
  display: flex;
  align-items: center;
}
.search-box i.fa-search[data-v-f8a3953c] {
  position: absolute;
  left: 12px;
  color: #6c757d;
  pointer-events: none;
}
.search-input[data-v-f8a3953c] {
  width: 100%;
  padding: 10px 40px 10px 40px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}
.search-input[data-v-f8a3953c]:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
.clear-search[data-v-f8a3953c] {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.clear-search[data-v-f8a3953c]:hover {
  background: #f8f9fa;
  color: #495057;
}
.search-results-info[data-v-f8a3953c] {
  margin-top: 8px;
  font-size: 13px;
  color: #6c757d;
  font-style: italic;
}
.loading-state[data-v-f8a3953c],
.no-templates[data-v-f8a3953c] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
  gap: 12px;
}
.loading-state i[data-v-f8a3953c],
.no-templates i[data-v-f8a3953c] {
  font-size: 48px;
  color: #007bff;
}
.no-templates p[data-v-f8a3953c] {
  margin: 0;
  font-size: 16px;
}
.no-results[data-v-f8a3953c] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
  gap: 12px;
  background: white;
  border-radius: 8px;
  margin-top: 20px;
}
.no-results i[data-v-f8a3953c] {
  font-size: 48px;
  color: #6c757d;
}
.no-results p[data-v-f8a3953c] {
  margin: 0;
  font-size: 16px;
}
.templates-table-container[data-v-f8a3953c] {
  overflow-x: auto;
}
.pagination-container[data-v-f8a3953c] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 12px;
}
.pagination-info[data-v-f8a3953c] {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
}
.pagination-controls[data-v-f8a3953c] {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pagination-btn[data-v-f8a3953c],
.page-number[data-v-f8a3953c] {
  background: white;
  border: 1px solid #dee2e6;
  color: #495057;
  cursor: pointer;
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination-btn[data-v-f8a3953c]:hover:not(:disabled),
.page-number[data-v-f8a3953c]:hover:not(.active) {
  background: #f8f9fa;
  border-color: #007bff;
  color: #007bff;
}
.pagination-btn[data-v-f8a3953c]:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.page-numbers[data-v-f8a3953c] {
  display: flex;
  gap: 4px;
}
.page-number.active[data-v-f8a3953c] {
  background: #007bff;
  border-color: #007bff;
  color: white;
  font-weight: 600;
}
.items-per-page[data-v-f8a3953c] {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #495057;
}
.items-per-page label[data-v-f8a3953c] {
  font-weight: 500;
  margin: 0;
}
.items-per-page select[data-v-f8a3953c] {
  padding: 6px 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: white;
  color: #495057;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}
.items-per-page select[data-v-f8a3953c]:hover {
  border-color: #007bff;
}
.items-per-page select[data-v-f8a3953c]:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
.templates-table[data-v-f8a3953c] {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.templates-table thead[data-v-f8a3953c] {
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
}
.templates-table th[data-v-f8a3953c] {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #dee2e6;
}
.templates-table td[data-v-f8a3953c] {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: top;
}
.templates-table tr.inactive[data-v-f8a3953c] {
  opacity: 0.6;
  background-color: #f8f9fa;
}
.templates-table tbody tr[data-v-f8a3953c]:hover:not(.inactive) {
  background-color: #f8f9fa;
}
.template-name[data-v-f8a3953c] {
  font-weight: 500;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 8px;
}
.inactive-badge[data-v-f8a3953c] {
  display: inline-block;
  padding: 2px 8px;
  background: #ffc107;
  color: #856404;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.template-subject[data-v-f8a3953c] {
  font-weight: 500;
  color: #495057;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.template-body[data-v-f8a3953c] {
  max-width: 350px;
  max-height: 80px;
  overflow: hidden;
  color: #6c757d;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.template-body[data-v-f8a3953c] p {
  margin: 0 0 8px 0;
}
.template-body[data-v-f8a3953c] strong {
  color: #2c3e50;
}
.select-btn[data-v-f8a3953c] {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  white-space: nowrap;
}
.select-btn[data-v-f8a3953c]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.modal-footer[data-v-f8a3953c] {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
  gap: 12px;
  flex-shrink: 0;
  background: white;
}
.btn[data-v-f8a3953c] {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-secondary[data-v-f8a3953c] {
  background: #6c757d;
  color: white;
}
.btn-secondary[data-v-f8a3953c]:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.btn-primary[data-v-f8a3953c] {
  background: #007bff;
  color: white;
}
.btn-primary[data-v-f8a3953c]:hover:not(:disabled) {
  background: #0056b3;
}
@media (max-width: 768px) {
.modal-container[data-v-f8a3953c] {
    max-width: 100%;
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
}
.templates-table[data-v-f8a3953c] {
    font-size: 12px;
}
.templates-table th[data-v-f8a3953c],
  .templates-table td[data-v-f8a3953c] {
    padding: 8px;
}
.template-subject[data-v-f8a3953c],
  .template-body[data-v-f8a3953c] {
    max-width: 150px;
}
.pagination-container[data-v-f8a3953c] {
    flex-direction: column;
    align-items: stretch;
}
.pagination-info[data-v-f8a3953c],
  .items-per-page[data-v-f8a3953c] {
    justify-content: center;
}
.pagination-controls[data-v-f8a3953c] {
    justify-content: center;
    flex-wrap: wrap;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/wizard/modals/TemplateSelectionModal.vue"],"names":[],"mappings":";AAkSA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,oCAA2B;AAC7B;AAEA;AACE;IACE,UAAU;AACZ;AACA;IACE,UAAU;AACZ;AACF;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kEAAyD;EACzD,gBAAgB;AAClB;AAEA;AACE;IACE,uCAAuC;IACvC,UAAU;AACZ;AACA;IACE,iCAAiC;IACjC,UAAU;AACZ;AACF;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,6DAA6D;AAC/D;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,SAAS;AACX;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;AACrB;AAEA;AACE;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AAClB;AAEA;IACE,eAAe;AACjB;AAEA;;IAEE,YAAY;AACd;AAEA;;IAEE,gBAAgB;AAClB;AAEA;IACE,sBAAsB;IACtB,oBAAoB;AACtB;AAEA;;IAEE,uBAAuB;AACzB;AAEA;IACE,uBAAuB;IACvB,eAAe;AACjB;AACF","sourcesContent":["<template>\n  <div v-if=\"isVisible\" class=\"modal-overlay\" @click=\"handleOverlayClick\">\n    <div class=\"modal-container\" @click.stop>\n      <div class=\"modal-header\">\n        <h3>Select Message Template</h3>\n        <button class=\"close-button\" @click=\"closeModal\" aria-label=\"Close\">\n          <span>&times;</span>\n        </button>\n      </div>\n\n      <div class=\"modal-body\">\n        <!-- Loading State -->\n        <div v-if=\"loading\" class=\"loading-state\">\n          <i class=\"fa fa-spinner fa-spin\"></i>\n          <span>Loading templates...</span>\n        </div>\n\n        <!-- No Templates -->\n        <div v-else-if=\"templates.length === 0\" class=\"no-templates\">\n          <i class=\"fa fa-info-circle\"></i>\n          <p>No templates available for this crisis type.</p>\n        </div>\n\n        <!-- Search Bar -->\n        <div v-else class=\"search-container\">\n          <div class=\"search-box\">\n            <i class=\"fa fa-search\"></i>\n            <input\n              type=\"text\"\n              v-model=\"searchQuery\"\n              placeholder=\"Search by name or subject...\"\n              class=\"search-input\"\n            />\n            <button\n              v-if=\"searchQuery\"\n              class=\"clear-search\"\n              @click=\"searchQuery = ''\"\n              aria-label=\"Clear search\"\n            >\n              <i class=\"fa fa-times\"></i>\n            </button>\n          </div>\n          <div class=\"search-results-info\" v-if=\"searchQuery\">\n            Showing {{ filteredTemplates.length }} of {{ templates.length }} templates\n          </div>\n        </div>\n\n        <!-- Templates Table -->\n        <div v-if=\"!loading && templates.length > 0\" class=\"templates-table-container\">\n          <table class=\"templates-table\">\n            <thead>\n              <tr>\n                <th>Name</th>\n                <th>Subject (EN)</th>\n                <th>Body (EN)</th>\n                <th>Action</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr\n                v-for=\"template in paginatedTemplates\"\n                :key=\"template.id\"\n                :class=\"{ inactive: !template.isActive }\"\n              >\n                <td>\n                  <div class=\"template-name\">\n                    {{ template.name }}\n                    <span v-if=\"!template.isActive\" class=\"inactive-badge\">Inactive</span>\n                  </div>\n                </td>\n                <td>\n                  <div class=\"template-subject\">{{ template.subjectEn }}</div>\n                </td>\n                <td>\n                  <div class=\"template-body\" v-html=\"template.bodyEn\"></div>\n                </td>\n                <td>\n                  <button\n                    class=\"btn btn-sm btn-primary select-btn\"\n                    @click=\"selectTemplate(template)\"\n                    :disabled=\"!template.isActive\"\n                  >\n                    <i class=\"fa fa-check\"></i>\n                    Select\n                  </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n\n          <!-- No Results Message -->\n          <div v-if=\"filteredTemplates.length === 0\" class=\"no-results\">\n            <i class=\"fa fa-search\"></i>\n            <p>No templates match your search criteria.</p>\n            <button class=\"btn btn-sm btn-secondary\" @click=\"searchQuery = ''\">\n              Clear Search\n            </button>\n          </div>\n\n          <!-- Pagination Controls -->\n          <div v-if=\"filteredTemplates.length > 0\" class=\"pagination-container\">\n            <div class=\"pagination-info\">\n              Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredTemplates.length }} templates\n            </div>\n            \n            <div class=\"pagination-controls\">\n              <button\n                class=\"pagination-btn\"\n                @click=\"goToFirstPage\"\n                :disabled=\"currentPage === 1\"\n                aria-label=\"First page\"\n              >\n                <i class=\"fa fa-angle-double-left\"></i>\n              </button>\n              \n              <button\n                class=\"pagination-btn\"\n                @click=\"previousPage\"\n                :disabled=\"currentPage === 1\"\n                aria-label=\"Previous page\"\n              >\n                <i class=\"fa fa-angle-left\"></i>\n              </button>\n              \n              <div class=\"page-numbers\">\n                <button\n                  v-for=\"page in visiblePages\"\n                  :key=\"page\"\n                  class=\"page-number\"\n                  :class=\"{ active: page === currentPage }\"\n                  @click=\"goToPage(page)\"\n                >\n                  {{ page }}\n                </button>\n              </div>\n              \n              <button\n                class=\"pagination-btn\"\n                @click=\"nextPage\"\n                :disabled=\"currentPage === totalPages\"\n                aria-label=\"Next page\"\n              >\n                <i class=\"fa fa-angle-right\"></i>\n              </button>\n              \n              <button\n                class=\"pagination-btn\"\n                @click=\"goToLastPage\"\n                :disabled=\"currentPage === totalPages\"\n                aria-label=\"Last page\"\n              >\n                <i class=\"fa fa-angle-double-right\"></i>\n              </button>\n            </div>\n\n            <div class=\"items-per-page\">\n              <label for=\"itemsPerPage\">Items per page:</label>\n              <select id=\"itemsPerPage\" v-model.number=\"itemsPerPage\">\n                <option :value=\"5\">5</option>\n                <option :value=\"10\">10</option>\n                <option :value=\"25\">25</option>\n                <option :value=\"50\">50</option>\n              </select>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-secondary\" @click=\"closeModal\">\n          Cancel\n        </button>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: \"TemplateSelectionModal\",\n  props: {\n    isVisible: { type: Boolean, required: true },\n    templates: { type: Array, required: true },\n    loading: { type: Boolean, default: false },\n  },\n  data() {\n    return {\n      searchQuery: \"\",\n      currentPage: 1,\n      itemsPerPage: 10,\n    };\n  },\n  computed: {\n    filteredTemplates() {\n      if (!this.searchQuery.trim()) {\n        return this.templates;\n      }\n\n      const query = this.searchQuery.toLowerCase().trim();\n      return this.templates.filter((template) => {\n        const name = (template.name || \"\").toLowerCase();\n        const subject = (template.subjectEn || \"\").toLowerCase();\n        return name.includes(query) || subject.includes(query);\n      });\n    },\n    totalPages() {\n      return Math.ceil(this.filteredTemplates.length / this.itemsPerPage);\n    },\n    startIndex() {\n      return (this.currentPage - 1) * this.itemsPerPage;\n    },\n    endIndex() {\n      return Math.min(this.startIndex + this.itemsPerPage, this.filteredTemplates.length);\n    },\n    paginatedTemplates() {\n      return this.filteredTemplates.slice(this.startIndex, this.endIndex);\n    },\n    visiblePages() {\n      const pages = [];\n      const maxVisible = 5;\n      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));\n      let end = Math.min(this.totalPages, start + maxVisible - 1);\n\n      // Adjust start if we're near the end\n      if (end - start < maxVisible - 1) {\n        start = Math.max(1, end - maxVisible + 1);\n      }\n\n      for (let i = start; i <= end; i++) {\n        pages.push(i);\n      }\n      return pages;\n    },\n  },\n  watch: {\n    isVisible(newVal) {\n      // Clear search and reset pagination when modal is closed\n      if (!newVal) {\n        this.searchQuery = \"\";\n        this.currentPage = 1;\n      }\n    },\n    searchQuery() {\n      // Reset to first page when search query changes\n      this.currentPage = 1;\n    },\n    itemsPerPage() {\n      // Reset to first page when items per page changes\n      this.currentPage = 1;\n    },\n  },\n  methods: {\n    handleOverlayClick(event) {\n      if (event.target === event.currentTarget) {\n        this.closeModal();\n      }\n    },\n    closeModal() {\n      this.$emit(\"close\");\n    },\n    selectTemplate(template) {\n      this.$emit(\"select-template\", template);\n      this.closeModal();\n    },\n    goToPage(page) {\n      if (page >= 1 && page <= this.totalPages) {\n        this.currentPage = page;\n      }\n    },\n    nextPage() {\n      if (this.currentPage < this.totalPages) {\n        this.currentPage++;\n      }\n    },\n    previousPage() {\n      if (this.currentPage > 1) {\n        this.currentPage--;\n      }\n    },\n    goToFirstPage() {\n      this.currentPage = 1;\n    },\n    goToLastPage() {\n      this.currentPage = this.totalPages;\n    },\n  },\n};\n</script>\n\n<style scoped>\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20000;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  overflow: hidden;\n}\n\n@keyframes slideIn {\n  from {\n    transform: scale(0.9) translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-header {\n  padding: 20px 24px;\n  border-bottom: 2px solid #007bff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: white;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: white;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.modal-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n  background: #fafafa;\n}\n\n.search-container {\n  margin-bottom: 20px;\n  background: white;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box i.fa-search {\n  position: absolute;\n  left: 12px;\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 40px 10px 40px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.clear-search {\n  position: absolute;\n  right: 8px;\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.clear-search:hover {\n  background: #f8f9fa;\n  color: #495057;\n}\n\n.search-results-info {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.loading-state,\n.no-templates {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #6c757d;\n  gap: 12px;\n}\n\n.loading-state i,\n.no-templates i {\n  font-size: 48px;\n  color: #007bff;\n}\n\n.no-templates p {\n  margin: 0;\n  font-size: 16px;\n}\n\n.no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #6c757d;\n  gap: 12px;\n  background: white;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.no-results i {\n  font-size: 48px;\n  color: #6c757d;\n}\n\n.no-results p {\n  margin: 0;\n  font-size: 16px;\n}\n\n.templates-table-container {\n  overflow-x: auto;\n}\n\n.pagination-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 20px;\n  padding: 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.pagination-info {\n  font-size: 14px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pagination-btn,\n.page-number {\n  background: white;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  cursor: pointer;\n  padding: 6px 10px;\n  font-size: 14px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-btn:hover:not(:disabled),\n.page-number:hover:not(.active) {\n  background: #f8f9fa;\n  border-color: #007bff;\n  color: #007bff;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.page-numbers {\n  display: flex;\n  gap: 4px;\n}\n\n.page-number.active {\n  background: #007bff;\n  border-color: #007bff;\n  color: white;\n  font-weight: 600;\n}\n\n.items-per-page {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #495057;\n}\n\n.items-per-page label {\n  font-weight: 500;\n  margin: 0;\n}\n\n.items-per-page select {\n  padding: 6px 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: white;\n  color: #495057;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.items-per-page select:hover {\n  border-color: #007bff;\n}\n\n.items-per-page select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.templates-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.templates-table thead {\n  background: #f8f9fa;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.templates-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #2c3e50;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.templates-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: top;\n}\n\n.templates-table tr.inactive {\n  opacity: 0.6;\n  background-color: #f8f9fa;\n}\n\n.templates-table tbody tr:hover:not(.inactive) {\n  background-color: #f8f9fa;\n}\n\n.template-name {\n  font-weight: 500;\n  color: #2c3e50;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.inactive-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  background: #ffc107;\n  color: #856404;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.template-subject {\n  font-weight: 500;\n  color: #495057;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.template-body {\n  max-width: 350px;\n  max-height: 80px;\n  overflow: hidden;\n  color: #6c757d;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.template-body >>> p {\n  margin: 0 0 8px 0;\n}\n\n.template-body >>> strong {\n  color: #2c3e50;\n}\n\n.select-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  white-space: nowrap;\n}\n\n.select-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px;\n  border-top: 1px solid #e9ecef;\n  gap: 12px;\n  flex-shrink: 0;\n  background: white;\n}\n\n.btn {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .modal-container {\n    max-width: 100%;\n    width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .templates-table {\n    font-size: 12px;\n  }\n\n  .templates-table th,\n  .templates-table td {\n    padding: 8px;\n  }\n\n  .template-subject,\n  .template-body {\n    max-width: 150px;\n  }\n\n  .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pagination-info,\n  .items-per-page {\n    justify-content: center;\n  }\n\n  .pagination-controls {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
